import { useEffect } from 'react';
import { useInView } from 'react-intersection-observer';

import { trackSectionView } from './analytics';

/**
 * Reports a home-page section as seen, once, when a third of it has
 * scrolled into view. Page views alone can't tell you whether anyone got
 * past the hero.
 *
 * Usage: `const ref = useSectionView('collection');` then put `ref` on
 * the section element.
 */
export default function useSectionView(section) {
  const [ref, inView] = useInView({ triggerOnce: true, threshold: 0.3 });

  useEffect(() => {
    if (inView) trackSectionView(section);
  }, [inView, section]);

  return ref;
}
